module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Liverpool.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Liverpool.png
// module id = 2189
// module chunks = 4